var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ffffff",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    width: "250px",
    height: "250px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.517,34.378l-3.221-6.089c-0.122-0.226-0.248-0.644-0.378-1.252h-0.052c-0.061,0.287-0.205,0.722-0.431,1.304l-3.233,6.037h-5.02l5.959-9.349l-5.45-9.35h5.125l2.673,5.607c0.209,0.443,0.396,0.969,0.561,1.578H15.1c0.104-0.365,0.3-0.909,0.587-1.63l2.973-5.555h4.694l-5.607,9.271l5.764,9.427H18.517z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M29,43h18c0.552,0,1-0.448,1-1s0-33.448,0-34s-0.448-1-1-1H29"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ffffff",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M29 36L34 36M36 36L44 36M29 28L34 28M36 28L44 28M29 21L34 21M36 21L44 21M29 14L34 14M36 14L44 14"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M1,6.333v37.334L29,49V1L1,6.333z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.db74479dcdd7ef41029f765302ea8043.svg";
export { ForwardRef as ReactComponent };